// Reglas de validación compartidas por el servidor y la vista previa del navegador (cuentas de agencia y soporte).
export const MIN_CLAVE = 8;
export const normalizarUsuario = (u: unknown) => String(u ?? "").trim().toLowerCase();

export type DatosCuenta = { usuario: string; clave: string };

export function validarUsuario(u: string): string | null {
  return /^[a-z0-9][a-z0-9._-]{2,29}$/.test(u) ? null : "El usuario debe tener de 3 a 30 letras, números, punto o guion";
}
export function validarClave(c: string): string | null {
  return c.length >= MIN_CLAVE ? null : `La contraseña debe tener al menos ${MIN_CLAVE} caracteres`;
}

export type RegistroAgencia = { nombre: string; contacto: string; telefono: string; correo: string; ciudad: string; usuario: string; clave: string };

/** Devuelve el primer error en español o null si todo está bien. Normaliza usuario, teléfono y correo. */
export function validarRegistro(d: Partial<RegistroAgencia>): { error: string | null; datos: RegistroAgencia } {
  const datos: RegistroAgencia = {
    nombre: String(d.nombre ?? "").trim(), contacto: String(d.contacto ?? "").trim(), telefono: String(d.telefono ?? "").replace(/[\s()-]/g, ""),
    correo: String(d.correo ?? "").trim().toLowerCase(), ciudad: String(d.ciudad ?? "").trim(), usuario: normalizarUsuario(d.usuario), clave: String(d.clave ?? ""),
  };
  const error =
    (!datos.nombre ? "Escribe el nombre de la agencia" : null) ??
    (!datos.contacto ? "Escribe el nombre de la persona de contacto" : null) ??
    (!/^\d{10}$/.test(datos.telefono) ? "El teléfono debe tener 10 dígitos" : null) ??
    (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(datos.correo) ? "Escribe un correo válido" : null) ??
    validarUsuario(datos.usuario) ?? validarClave(datos.clave);
  return { error, datos };
}

export type DatosTicket = { origen: string; agenciaId?: string; contacto?: string; asunto: string; mensaje: string; folio?: string };
export const ORIGENES = ["cliente", "agencia", "equipo"] as const;
export function validarTicket(d: Partial<DatosTicket>): { error: string | null; datos: DatosTicket } {
  const datos: DatosTicket = {
    origen: String(d.origen ?? ""), agenciaId: d.agenciaId ? String(d.agenciaId) : undefined, contacto: String(d.contacto ?? "").trim().slice(0, 120) || undefined,
    asunto: String(d.asunto ?? "").trim(), mensaje: String(d.mensaje ?? "").trim(), folio: String(d.folio ?? "").trim().toUpperCase().slice(0, 30) || undefined,
  };
  const error =
    (!(ORIGENES as readonly string[]).includes(datos.origen) ? "Origen no válido" : null) ??
    (datos.asunto.length < 3 ? "Escribe el asunto" : datos.asunto.length > 120 ? "El asunto es muy largo (máximo 120 letras)" : null) ??
    (datos.mensaje.length < 5 ? "Cuéntanos qué pasó" : datos.mensaje.length > 2000 ? "El mensaje es muy largo (máximo 2000 letras)" : null) ??
    (datos.origen === "agencia" && !datos.agenciaId ? "Falta la agencia" : null);
  return { error, datos };
}

export const numeroTicket = (serie: number) => `SOP-${String(serie).padStart(4, "0")}`;
